import { APICore } from './apiCore';

const api = new APICore();

// Get Order Details
function getOrderDetails(orderId: string) {
    const baseUrl = `/orders/${orderId}`;
    return api.get(baseUrl, '');
}

// Update Order Status
function updateOrder(
    vendorId: number,
    orderId: string
) {
    const baseUrl = `/vendors/${vendorId}/orders/${orderId}/status`;
    return api.update(baseUrl, {});
}

export {
    getOrderDetails,
    updateOrder,
};